import {
  call, put, select, delay, spawn
} from 'redux-saga/effects';
import dynamic from 'next/dynamic';
import { actions as modalActions } from '@gc-npm/reducers.modals-reducer';
import isWebview from "@gc-npm/utils.common.is-webview";
import isColApp from "@gc-npm/utils.common.is-colapp";
import getUUID from '@gc-npm/utils.monitoring.get-uuid';
import {
  CONTENT_POSITION,
  IN_SCENE_EFFECT,
  OUT_SCENE_EFFECT,
} from '@gc-npm/components.modal';
import FrontSonda from '@gc-npm/utils.monitoring.front-sonda';
import sendGaEvent from '@gc-npm/utils.metrics.send-ga-component-event';
import LocalStorageLib from '@gc-npm/utils.secure.local-storage';
import normalizeCustomerInfo from '@gc-npm/normalizers.adabyron.abs-layer.customer-info';
import sendRetargeting from '@gc-npm/adabyron.misc.send-retargeting'
import send2SE from '@gc-npm/adabyron.catalogue.send-to-se';
import { getClientsIds } from '@gc-npm/utils.c2c';
import { redeemCampaign as redeemCampaignAda } from '@gc-npm/adabyron.misc.redeem-campaign';
const {  CloudTraceService } = require('@gc-npm/gcp-services.open-telemetry');
import { actions as uiActions } from '@/reducers/ui';
import { actions as clientActions } from '@/reducers/client';
import {
  getR2rTypeByApi,
  normalizeUserBundleExtraInfo,
} from '@/sagas/normalizers/client';
import {
  LAYOUT_TYPES,
  API_STATUS,
  SCREEN_TYPES,
  URL_LOGIN,
  PRODUCT_OFFERING_TYPES,
  CONFIRMATION_STATUS,
  CONFIRMATION_TYPES,
  URL_REFRESH,
  URL_FULL_CONFIG,
  CONECTIVIDAD_BASE_ID,
  TIPOS_R2R,
  URL_ORIGIN,
  CONECTIVIDAD_ESENCIAL,
  PURCHASE_PROCESS_KINDS,
  BACK_OFFICE_CAMPAIGN,
  LOGIN_TYPES,
  PUSSUB_STATES_DICTIONARY,
} from '@/utils/constants';
import {
  getUrlParams,
  sendPubSubMessage,
  parseUserAgentInfo,
  getTaponInfo,
  notifyColAppOperationSuccess,
} from '@/utils/index';

import LegalsModal from '@/components/Modals/LegalsModal';
import { getMyData } from '@/sagas/client';
import { initModules, safeParseSessionStorage } from '@/sagas/modules';
import { initRecomendator } from '@/sagas/recomendator';

const filePath = '/sagas/ui.js';
const RETENTION_ACTIONS = Object.freeze({
  ONE_CLICK: 'oneClick',
  BACK_OFFICE: 'backOffice',
  BACK_OFFICE_ERROR: 'backOfficeError',
});

const mainStore = (state) => state.main;
const clientStore = (state) => state.client;
const uiStore = (state) => state.UI;
const cartStore = (state) => state.cart;
const recomendatorStore = (state) => state.recomendator;
const getReCaptchaToken = ({ action = 'default' }) => {
  return new Promise((resolve) => {
    if (typeof window === 'undefined' || !window.grecaptcha) {
      resolve(null);
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(process.env.NEXT_PUBLIC_LAYER_RECAPTCHA_ID, { action })
        .then((token) => {
          resolve(token);
        });
    });
  });
};

function* getuserAgent(isClient) {
  
  const isWebviewBol = isWebview();
  let customUserAgent = isWebviewBol ? 'webview' : 'web';

  if(navigator?.userAgent) {
    customUserAgent = parseUserAgentInfo(navigator?.userAgent, isClient) 
  }

  yield put(uiActions.setUserAgent(customUserAgent));
  return customUserAgent;
}

// función para mandar el evento de tageo del tapon
export function* sendTaponMetrics({ tapon }) {
  const { componentProduct, componentContent } = tapon || {};
  const ui = yield select(uiStore);
  const processId = ui?.processID;
  const userAgent = ui?.userAgent;
    let main = yield select(mainStore);
  const { context } = main;
  const taggingInfo = {
    componentName: 'tapon-mimovistar',
    componentContent: componentContent || 'tapon-mimovistar',
    componentProduct: componentProduct || 'tapon-mimovistar',
    componentVariation:
      ui?.urlParams && ui.urlParams?.Ap_Tcol
        ? 'area-privada'
        : 'home-mimovistar',
  };
yield spawn(sendPubSubMessage, {
  processId,
  context,
  state: PUSSUB_STATES_DICTIONARY.TAPON,
  stateMessage: [componentContent, componentProduct?.statusCode]
    .filter(v => v !== undefined && v !== null && v !== '')
    .join(' -- '),
  userAgent
});
  sendGaEvent({ ...taggingInfo, eventType: 'print-success' });
}

function* getLayout() {
  let layout = LAYOUT_TYPES.RECOMENDATOR;
  if (typeof window !== 'undefined' && window.location) {
    const url = new URL(window.location.href);
    if (url && url.pathname) {
      if (url.pathname.includes('conectividad')) {
        layout = LAYOUT_TYPES.CONECTIVIDAD;
      } else if (url.pathname.includes('tv')) {
        layout = LAYOUT_TYPES.TV;
      } else if (url.pathname.includes('configurador')) {
        layout = LAYOUT_TYPES.ALL;
      } else if (url.pathname.includes('promo')) {
        layout = LAYOUT_TYPES.PROMO;
      }
    }
  }

  yield put(uiActions.setLayout(layout));
  return layout;
}

function* getProcessId() {
  const processId = getUUID('', '', false);
  
  yield put(uiActions.setProcessId(processId));
  return processId;
}

const getUrlDestino = (params) => {
  const { pathname } = new URL(window.location.href);
  let urlDestino = `${URL_ORIGIN}${pathname}`;
  if (params && Object.keys(params).length > 0) {
    urlDestino = `${urlDestino}?`;
    const urlParams = [];
    const paramsKeys = Object.keys(params);
    paramsKeys.forEach((paramKey) => {
      let paramValue = params[paramKey];
      if (typeof paramValue !== undefined && paramValue !== null) {
        if (Array.isArray(paramValue)) {
          paramValue = params[paramKey].join(';');
        }
        urlParams.push(`${paramKey}=${paramValue}`);
      }
    });
    urlDestino += urlParams.join('&');
  }

  return urlDestino;
};

export const navigate2Login = (params) => {
  const urlDestino = getUrlDestino(params);
  const url2Go = `${URL_LOGIN}${encodeURIComponent(urlDestino)}`;
  if (typeof window !== 'undefined') {
    window.location.href = url2Go;
  }
  return null;
};

export const navigate2Refresh = (params) => {
  const urlDestino = getUrlDestino(params);
  const url2Go = `${URL_REFRESH}${encodeURIComponent(urlDestino)}`;
  if (typeof window !== 'undefined') {
    window.location.href = url2Go;
  }
  return null;
};

export function* navigate2Url({ url, params, target, client }) {
  let url2Go = url;
  if (params && Object.keys(params).length > 0) {
    url2Go = `${url2Go}?`;
    const paramsKeys = Object.keys(params);
    paramsKeys.forEach((paramKey, key) => {
      url2Go += `${paramKey}=${params[paramKey]}${key < paramsKeys.length - 1 ? '&' : ''}`;
    });
  }

  if (url2Go && typeof window !== 'undefined') {
    if (target === '_blank') {
      window.open(url2Go, target);
    } else {
      window.location.href = url2Go;
    }
  } else {
    yield put(
      uiActions.setTapon({
        ...getTaponInfo(client, '500'),
        componentContent: 'Fallo en navigate2Url',
        componentProduct: 'navigate2Url',
      }),
    );
  }
  return null;
}

function* waitForUserBundle() {
  let retries = 10;
  while (retries > 0) {
    const { userBundle } = yield select(mainStore);
    if (userBundle) return userBundle;
    yield delay(50);
    retries--;
  }
  return null;
}

function* redirectToLogin(frontSonda, userType, layout, urlParams) {
  frontSonda.warningMessage({
    info: `MANDAMOS A LOGIN: userType: ${userType}, layout : ${layout}`,
  });
  return yield call(navigate2Login, urlParams);
}

function* redirectToFullConfig(frontSonda, client, layout, urlParams) {
  frontSonda.warningMessage({
    info: `REDIRECCIÓN a configurador - layout: ${layout}, client: ${JSON.stringify(client)}, urlParams: ${urlParams}`,
  });
  return yield call(navigate2Url, { url: URL_FULL_CONFIG, params: urlParams , client});
}

function computeR2rType(main, client, CONECTIVIDAD_BASE_ID, CONECTIVIDAD_ESENCIAL, TIPOS_R2R) {
  // tipo inicial por API
  let tipoR2r = getR2rTypeByApi(main?.userPq?.clt);

  const hasR2rIncHired = main?.userCompatibilities?.r2r?.hiredR2R?.length > 0;

  if (!hasR2rIncHired) {
    const bundleModules = client?.bundleModules ?? [];
    const hasConnectivity =
      bundleModules.includes(CONECTIVIDAD_BASE_ID) ||
      bundleModules.includes(CONECTIVIDAD_ESENCIAL);

    if (hasConnectivity) {
      tipoR2r = TIPOS_R2R.ADICIONAL;
    }
  }
  return tipoR2r;
}


export function* checkIfClientConexionWithOutSpeed(client, context, urlParams) {
  if (
    client &&
    client?.productType === PRODUCT_OFFERING_TYPES.PRODUCTS.MIMOVISTAR.ID &&
    Array.isArray(client?.bundleModules) &&
    client?.bundleModules.length > 0
  ) {
    const alreadyRefreshed = safeParseSessionStorage('alreadyRefreshed');
    const isWebviewBol = isWebview();
    const isColAppBool = isColApp();
    if((!isWebviewBol && !isColAppBool) &&  !alreadyRefreshed) {
      for (const eachModule of client.bundleModules) {
      if (typeof eachModule === 'string') {

        const startsWith10 = /^10\d/.test(eachModule);
        const hasDash = eachModule.includes('-');
       
        // empieza por 10 pero NO tiene guion -> refresh
        if (startsWith10 && !hasDash) {
           sessionStorage.setItem('alreadyRefreshed', true);
           const processId = yield call(getProcessId)
            const ui = yield select(uiStore);
            const userAgent = ui?.userAgent;
           yield spawn(sendPubSubMessage, {processId, context, state: PUSSUB_STATES_DICTIONARY.INIT_REFRESH_OLD_CONECTIVITY,userAgent, stateMessage: `${client.bundleModules.join(';;')}` });
           yield call(navigate2Refresh, urlParams);
        }
      }
    }
    }
    
  }
};

// función para mandar el evento de tageo del tapon, necesarios componentProduct, componentContent
export function* initializeConfig({ build, mode, isProductosRecomendados, rule, urlParams: urlParamsFromAction }) {

  const cloudTraceServiceInit = new CloudTraceService('front/initializeConfig');

  cloudTraceServiceInit.startSpan()
  let main = yield select(mainStore);
  const { context, zone } = main;

  const recomendator = yield select(recomendatorStore);
  const isRecomendatorInitialized = mode === 'recom'
    && !isProductosRecomendados
    && recomendator?.status?.init === API_STATUS.OK;

  if (!build && isRecomendatorInitialized) {
    cloudTraceServiceInit.endSpan();
    return null;
  }

  const layout = yield call(getLayout);
  const { userType } = context;
  let { userBundle, userCompatibilities, userPq, userPo, customer } = main;
  

  const frontSonda = new FrontSonda({
    processName: 'initializeConfig',
    context,
    filePath,
  });

  // obtengo parametros de url
  const urlParams = urlParamsFromAction || getUrlParams();
  if(urlParams && urlParams.directBuyProcess) {
    yield put(uiActions.setBouncingLogo(true))
  }
  // Obtengo tipo de disposicion
  
  const processId = yield call(getProcessId);
  // Obtengo recomendador
  if (mode === 'recom') {
    yield call(initRecomendator, { build, urlParams, isProductosRecomendados, rule });
  }
  
  if (userType === 'Telco' && !userBundle) {
    userBundle = yield call(waitForUserBundle);
  }

  let client = (userType === 'Telco' ||  userBundle) ? normalizeUserBundleExtraInfo(main) : null;
  const userAgent = yield call(getuserAgent,( userType === 'Telco' ||  userBundle));
  yield spawn(sendPubSubMessage, {processId,userAgent, context, state: PUSSUB_STATES_DICTIONARY.INIT, stateMessage: '' });

  let sessionZone = client?.productZoneId ?? zone;
  // comprobación para mandarlo a refresh por si tiene conectividad vieja sin la velocidad 
  if(client) {
    yield call(checkIfClientConexionWithOutSpeed,client, context, urlParams)
  }
  switch (layout) {
    case LAYOUT_TYPES.TV:
      if (!build) {
        // redirectLogin
        if (!userType) return yield call(redirectToLogin, frontSonda, userType, layout, urlParams);
        // redirectToFullConfig
        if (!client || client.productType !== PRODUCT_OFFERING_TYPES.PRODUCTS.MIMOVISTAR.ID) {
          return yield call(redirectToFullConfig, frontSonda, client, layout, urlParams);
        }
      }
      break;
    case LAYOUT_TYPES.ALL: {
      const tipoR2r = computeR2rType(main, client, CONECTIVIDAD_BASE_ID, CONECTIVIDAD_ESENCIAL, TIPOS_R2R);
      yield put(clientActions.setR2rType(tipoR2r));
      break;
    }
    case LAYOUT_TYPES.PROMO:
      // no esta logado
      if (!userType) return yield call(redirectToLogin, frontSonda, userType, layout, urlParams);
      // no es cliente valido o no tiene parametros validos
      if (
        !client
        || client.productType !== PRODUCT_OFFERING_TYPES.PRODUCTS.MIMOVISTAR.ID
        || !urlParams
        || (
          !urlParams.retentionModules
          && !urlParams.sendRetentionPromo
        )
      ) {
        return yield call(redirectToFullConfig, frontSonda, client, layout, urlParams);
      }
      break;
    // mirar fusion espejo
    default:
      break;
  }
  yield call(initModules, {
    build,
    client,
    sessionZone,
    urlParams,
  });
  if (!urlParams?.directBuyProcess) {
    yield put(uiActions.setBouncingLogo(false));
  }
  cloudTraceServiceInit.endSpan();
  return null;
}

export function* showNotification({ delayTime }) {
  let delayTimeToUse = 6000;
  if (delayTime && typeof delayTime === 'number') {
    delayTimeToUse = delayTime;
  }
  yield delay(delayTimeToUse);
  yield put(uiActions.resetNotification());
}

export function* getPermanenceFromModulos({ modulos }) {
  let permanence = 'Sin permanencia';

  if (modulos && Array.isArray(modulos) && modulos.length > 0) {
    const permanenceText = modulos.find(
      ({ hired, text4 }) => !hired && text4 && text4.text && text4.text.trim() !== '',
    )?.text4?.text;

    if (permanenceText) {
      permanence = permanenceText;
    }
  }

  yield put(uiActions.setPermanence(permanence));
}

const getData2Send = (info, misDatos, cart, userCompatibilities) => {
  const data2Send = {
    subject: '',
    contactPhone: '',
    contactEmail: '',
    message: '',
  };
  const {
    subject,
    bundle,
    subscriptions,
    unsubscriptions,
    targetAudienceRetention,
  } = info || {};
  data2Send.subject = targetAudienceRetention
    ? 'TELCOBI - COMPRA BUNDLE-REPO-AUTO'
    : subject;

  const fecha = new Date();
  const hora = fecha.getHours().toString().padStart(2, '0');
  const minutos = fecha.getMinutes().toString().padStart(2, '0');
  const segundos = fecha.getSeconds().toString().padStart(2, '0');

  const message = [];
  message.push(`
    HORA: ${hora}:${minutos}:${segundos}
  `);

  if (misDatos) {
    const {
      fullName,
      documentType,
      numberDocument,
      phone,
      sms,
      email,
    } = misDatos || {};

    const contactPhone = phone || sms;

    const datosCliente = `
      ::::::::::DATOS CLIENTE::::::::::
      NOMBRE: ${fullName}
      TIPO DE DOCUMENTO: ${documentType}
      DOCUMENTO: ${numberDocument}
      TELEFONO DE CONTACTO: ${contactPhone}
      EMAIL: ${email}
    `;
    message.push(datosCliente);

    data2Send.contactPhone = contactPhone;
    data2Send.contactEmail = email;
  }

  if (bundle) {
    const { id, alias } = bundle;
    const datosProducto = `
      ::::::::::DATOS PRODUCTO::::::::::
      :::::::::::: INFORMACION BUNDLE ::::::::::::
      BUNDLE IDPO: ${id}
      BUNDLE NOMBRE: ${alias}
    `;
    message.push(datosProducto);
  }

  if (
    subscriptions
    && Array.isArray(subscriptions)
    && subscriptions.length > 0
  ) {
    message.push(':::::::::::: INFORMACION VENTA ::::::::::::');
    const altas = [];
    subscriptions.forEach(({ id, alias }, index) => {
      altas.push(`
        IDPO ${index + 1} : ${id}
        NOMBRE ${index + 1} : ${alias}
      `);
    });
    message.push(altas.join('\n'));
  }

  if (
    unsubscriptions
    && Array.isArray(unsubscriptions)
    && unsubscriptions.length > 0
  ) {
    message.push(':::::::::::::::: BAJAS:::::::::::::::::::::::::::');
    const bajas = [];
    unsubscriptions.forEach(({ id, alias }, index) => {
      bajas.push(`
        BAJA IDPO ${index + 1} : ${id}
        BAJA NOMBRE ${index + 1} : ${alias}
      `);
    });
    message.push(bajas.join('\n'));
  }

  if (targetAudienceRetention) {
    const {
      productOfferingId,
      promotionIds,
      promotionDetails,
      finalPrice,
    } = targetAudienceRetention;
    const clientBundle = [
      userCompatibilities?.fa?.primaryBundle?.bundle,
      userCompatibilities?.sf?.primaryBundle?.bundle,
    ].find((bundleInfo) => (
      bundleInfo?.idPO != null
      && String(bundleInfo.idPO) === String(productOfferingId)
      && typeof bundleInfo.name === 'string'
      && bundleInfo.name.trim()
    ));

    const promotionsToShow = Array.isArray(promotionDetails)
      ? promotionDetails
      : promotionIds.map((promotionId) => ({
        id: promotionId,
        name: 'NO DISPONIBLE',
      }));
    const promotionInfo = promotionsToShow.map(({ id, name }, index) => `
      IDPROMO ${index + 1}: ${id}
      NOMBRE PROMO ${index + 1}: ${name || 'NO DISPONIBLE'}
    `).join('\n');
    const hasFinalPrice = (
      finalPrice !== null
      && finalPrice !== undefined
      && (typeof finalPrice !== 'string' || finalPrice.trim() !== '')
    );
    const normalizedFinalPrice = String(finalPrice)
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    const finalPriceText = hasFinalPrice
      ? `${normalizedFinalPrice}${/^\d+(?:[.,]\d+)?$/.test(normalizedFinalPrice) ? ' €/mes' : ''}`
      : 'NO DISPONIBLE';

    message.push(`
      :::::::::: RETENCIÓN DE PÚBLICO OBJETIVO ::::::::::
      PO CLIENTE: ${productOfferingId}
      PO NOMBRE: ${clientBundle?.name || 'NO DISPONIBLE'}
      ${promotionInfo}
      PRECIO FINAL: ${finalPriceText}
    `);
  }

  if (cart && !targetAudienceRetention) {
    if (cart.promotions && Array.isArray(cart.promotions) && cart.promotions.length > 0) {
      message.push('::::::::::::: INFORMACIÓN PROMOCIONES :::::::::::::');
      cart.promotions.forEach(({ id: idpp, texts: { legales: fullLegals } }, index) => {
        if (idpp && fullLegals) {
          const normalize = (text) => {
            return text
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '');
          };
          const normalizedLegals = normalize(fullLegals);
          const legals = normalizedLegals.indexOf('precio sin promocion') !== -1
            ? fullLegals.substring(0, index).trim()
            : fullLegals;
          message.push(`
            ID PROMO ${index + 1}: ${idpp}
            NOMBRE PROMO ${index + 1}: ${legals}
          `);
        }
      });
    }

    message.push(`
      ::::::::::::: INFORMACIÓN CARRO TOTAL :::::::::::::
      PRECIO TOTAL CON PROMO: ${cart.promoPrice}
      PRECIO TOTAL SIN PROMO: ${cart.price}
    `);
  }

  message.push(`
    :::::::::::: DATOS RIESGO ::::::::::::
    RIESGO: No
    CODIGO RIESGO: -

    :::::::::::: CHECK LEGALES ::::::::::::
    ACEPTA CONDICIONES: true
  `);

  data2Send.message = message.join('\n');

  return data2Send;
};

function* showCapaModalFicha(data) {
  const {
    url: capaUrl,
    directBuyProcess,
  } = data || {};

  const originUrl = getUrlDestino();
  const url = `${capaUrl}${capaUrl.includes('?') ? '&' : '?'}originUrl=${encodeURIComponent(originUrl)}`;

  if (directBuyProcess) {
    yield call(navigate2Url, { url });
  } else {
    yield put(uiActions.setBouncingLogo(false));
    const ModalWeb = dynamic(() => import('@gc-npm/components.cms-block.cms-modal-page'));
    const ui = yield select(uiStore);
    const { screenType } = ui;
    yield put(
      modalActions.addModal({
        id: `cms-modal-page${url.replace(/\//g, '--')}`,
        Element2Show: ModalWeb,
        modalProps: {
          closeIdByClickingOutside: '',
          opacityLayoutColor: 'blur',
          closeByClickingOutside: true,
          contentPosition:
                screenType === SCREEN_TYPES.MOBILE
                  ? CONTENT_POSITION.CENTER_BOTTOM
                  : CONTENT_POSITION.CENTER_CENTER,
          inSceneEffect:
                screenType === SCREEN_TYPES.MOBILE
                  ? IN_SCENE_EFFECT.FADE_IN_BOTTOM
                  : IN_SCENE_EFFECT.FADE_IN,
          outSceneEffect:
                screenType === SCREEN_TYPES.MOBILE
                  ? OUT_SCENE_EFFECT.FADE_OUT_BOTTOM
                  : OUT_SCENE_EFFECT.FADE_OUT,
          scrollAllowed: false,
          createAnchor: false,
        },
        elementProps: {
          url,
          width: '31rem',
        },
      }),
    );
  }
}

function* showLegalsModal(data) {
  const ui = yield select(uiStore);
  const { screenType } = ui;
  yield put(
    modalActions.addModal({
      id: 'LegalsModal',
      Element2Show: LegalsModal,
      modalProps: {
        closeByClickingOutside: false,
        contentPosition:
          screenType === SCREEN_TYPES.MOBILE
            ? CONTENT_POSITION.CENTER_BOTTOM
            : CONTENT_POSITION.CENTER_CENTER,
        inSceneEffect:
          screenType === SCREEN_TYPES.MOBILE
            ? IN_SCENE_EFFECT.FADE_IN_BOTTOM
            : IN_SCENE_EFFECT.FADE_IN,
        outSceneEffect:
          screenType === SCREEN_TYPES.MOBILE
            ? OUT_SCENE_EFFECT.FADE_OUT_BOTTOM
            : OUT_SCENE_EFFECT.FADE_OUT,
        opacityLayoutColor: 'blur',
        scrollAllowed: false,
      },
      elementProps: {
        screenType,
        data,
      },
    }),
  );
}

export function* sendOrder2BackOffice(info) {

  const { states, targetAudienceRetention } = info || {};
  const main = yield select(mainStore);
  const cart = yield select(cartStore);
  const { context } = main;

  const frontSonda = new FrontSonda({
    processName: 'sendOrder2BackOffice',
    context,
    filePath,
  });

  const misDatos = yield call(getMyData);

  if (
    misDatos === 401
    && !sessionStorage.getItem('backOfficeSend')
  ) {
    // si falla por login, la primera vez lo redirijo y reintento
    const backOfficeSendParse = JSON.stringify(info);
    sessionStorage.setItem('backOfficeSend', backOfficeSendParse);
    yield call(navigate2Login, { backOfficeSend: true });
  } else {
    sessionStorage.removeItem('backOfficeSend');
  }
  const data = getData2Send(info, misDatos, cart, main?.userCompatibilities);
  /* ENVIO A SE */
  try {
    const dataSended = yield call(send2SE, {
      data,
      context,
      version: '10',
    });
    if (dataSended?.status === 'OK') {
      const status = CONFIRMATION_STATUS.OK;
      frontSonda.warningMessage({
        info: 'Pedido a backoffice',
      });
      try {
          const localStorageLib = new LocalStorageLib();
          const persistedInfo = localStorageLib.getItem('ts');
          let campaignsRedeemed = persistedInfo?.customer?.campaigns?.redeemed;
          if (campaignsRedeemed && Array.isArray(campaignsRedeemed) && campaignsRedeemed.length > 0) {
            campaignsRedeemed.push({
              campaignId: BACK_OFFICE_CAMPAIGN,
            });
          } else {
            campaignsRedeemed = [
              {
                campaignId: BACK_OFFICE_CAMPAIGN,
              },
            ];
          }
          const updatedInfo = {
            ...persistedInfo,
            customer: {
              ...persistedInfo.customer,
              campaigns: {
                ...persistedInfo.customer?.campaigns,
                redeemed: campaignsRedeemed,
              },
            },
          };
          localStorageLib.setItem('ts', updatedInfo);

          const token = yield call(getReCaptchaToken, {
            action: 'order_tracking_client',
          });

          const redeemCampaignParams = {
            campaignId: BACK_OFFICE_CAMPAIGN,
            transactionId: dataSended?.datos?.idSE,
            token,
          };
          yield call(redeemCampaignAda, {
            data: redeemCampaignParams,
            context,
          });
          // GUARDAR EN SECURE LOCAL PARA TENERLO YA
      } catch (err) {
        frontSonda.warningMessage({
          info: `Fallo en el redeem nuevo config ${JSON.stringify(typeof err !== 'undefined' ? err : null)}`,
        });
      }
      // guardar en obj securejs
      yield put(
        uiActions.setConfirmation({
          type: CONFIRMATION_TYPES.BACKOFFICE,
          status,
          retentionProductName: targetAudienceRetention?.productName,
          info: states && states[status],
        }),
      );
      // el pedido ya esta en SE: un fallo aqui no debe convertir la confirmacion en KO
      try {
        yield call(notifyColAppOperationSuccess);
      } catch (error) {
        frontSonda.errorMessage({
          info: 'Fallo al notificar a col-app el pedido a backoffice',
          error,
        });
      }
    } else {
      throw new ReferenceError(
        'Send to SE error',
        filePath,
      );
    }
  } catch (error) {
    frontSonda.errorMessage({
      info: 'Fallo al enviar pedido a backoffice',
      error,
    });
    const status = CONFIRMATION_STATUS.KO;
  
    yield put(
      uiActions.setConfirmation({
        type: CONFIRMATION_TYPES.BACKOFFICE,
        status,
        retentionProductName: targetAudienceRetention?.productName,
        info: states && states[status],
      }),
    );
  }
}

function* sendC2C(data) {
  const main = yield select(mainStore);
  const { context } = main;
  const {
    name, phone, idCampaign, states,
  } = data || {};
  /* ENVIO RETARGETING */
  try {
    if (!name || !phone) {
      throw new ReferenceError('No tenemos info de misDatos', filePath);
    }
    const recaptchaToken = yield call(getReCaptchaToken, {
      action: 'retargeting_collect',
    });
    const retargeting = yield call(sendRetargeting, {
      data: {
        campaign: {
          id: idCampaign,
        },
        products: [],
        context: {
          url: btoa(context?.contextURL || window.location.href),
          ga: getClientsIds(context),
        },
        contactInfo: {
          name,
          phone,
        },
        recaptchaToken,
      },
      context,
    });
    if (retargeting !== false) {
      const status = CONFIRMATION_STATUS.OK;
      yield put(uiActions.setConfirmation({
        type: CONFIRMATION_TYPES.C2C,
        status,
        info: states && states[status],
      }));
    } else {
      throw new ReferenceError('Data Retargeting Failed', filePath);
    }
  } catch (error) {
    const status = CONFIRMATION_STATUS.KO;
    yield put(uiActions.setConfirmation({
      type: CONFIRMATION_TYPES.C2C,
      status,
      info: states && states[status],
    }));
    const frontSonda = new FrontSonda({
      processName: 'sendC2C_retargeting',
      context,
      filePath,
    });
    frontSonda.errorMessage({
      error,
      info: 'Fallo al enviar C2C a retargeting',
    });
  }
}

export function* navigate2PurchaseProcess({ purchaseProcess }) {
  const main = yield select(mainStore);
  const ui = yield select(uiStore);
  const cart = yield select(cartStore);
  const client = yield select(clientStore);
  const processId = ui?.processID;
  const userAgent = ui?.userAgent;
  const { context } = main;

  const { kind, url, reason } = purchaseProcess || {};

  const frontSonda = new FrontSonda({
    processName: 'navigate2PurchaseProcess',
    context,
    filePath,
  });

  switch (kind) {
    case PURCHASE_PROCESS_KINDS.URL: {
      yield spawn(sendPubSubMessage, {
        processId,
        userAgent,
        context,
        state: PUSSUB_STATES_DICTIONARY.PURCHASE.PROCESS.PROCESS_TO_GO,
        stateMessage: 'Telco',
      });

      if (url) {
        let url2go = url;

        if (reason) {
          url2go += `?reason=${reason}`;
        } else if (ui?.layout === LAYOUT_TYPES.TV) {
          url2go += '&pid=clic-boton-meinteresa-config-tv';
        } else if (ui?.layout === LAYOUT_TYPES.RECOMENDATOR) {
          url2go += '&pid=clic-boton-meinteresa-recomendador';
        } else {
          url2go += '&pid=clic-boton-meinteresa-config';
        }

        if (context?.userType && context?.envairoment?.name === 'prod') {
          // Cliente → login con redirect
          url2go = `${URL_LOGIN}${encodeURIComponent(url2go)}`;
        }

        yield call(navigate2Url, { url: url2go });
      } else {
        // ✅ TAPÓN RESUELTO POR reason
        frontSonda.warningMessage({
          info: `Tapón activado en purchase process. Reason: ${reason}`,
        });

        yield put(
          uiActions.setTapon(
            getTaponInfo(
              context?.userType,
              '500',      // status técnico genérico
              reason      // 👈 motivo de negocio
            ),
          ),
        );
      }
      break;
    }

    case PURCHASE_PROCESS_KINDS.CAPA: {
      yield spawn(sendPubSubMessage, {
        processId,
        userAgent,
        context,
        state: PUSSUB_STATES_DICTIONARY.PURCHASE.PROCESS.PROCESS_TO_GO,
        stateMessage: 'Capa',
      });

      const capaInfoParse = JSON.stringify(purchaseProcess);
      if (sessionStorage) {
        sessionStorage.setItem('capaInfo', capaInfoParse);

        if (client.loginType === LOGIN_TYPES.SOFTLOGGED) {
          const alreadySelectedModules = cart?.modulos?.items || [];
          const modulosToSave = alreadySelectedModules.map(item => item.id);
          sessionStorage.setItem(
            'modulosToApply',
            JSON.stringify(modulosToSave),
          );
        }
      }

      yield call(showCapaModalFicha, purchaseProcess);
      break;
    }

    case PURCHASE_PROCESS_KINDS.C2C: {
      yield put(uiActions.setBouncingLogo(false));

      yield spawn(sendPubSubMessage, {
        processId,
        userAgent,
        context,
        state: PUSSUB_STATES_DICTIONARY.PURCHASE.PROCESS.PROCESS_TO_GO,
        stateMessage: 'C2C',
      });

      yield call(sendC2C, purchaseProcess);
      break;
    }

    case PURCHASE_PROCESS_KINDS.BACKOFFICE: {
      yield put(uiActions.setBouncingLogo(false));

      if (context?.userType) {
        yield spawn(sendPubSubMessage, {
          processId,
          userAgent,
          context,
          state: PUSSUB_STATES_DICTIONARY.PURCHASE.PROCESS.PROCESS_TO_GO,
          stateMessage: 'BackOffice',
        });

        yield call(showLegalsModal, purchaseProcess);
      } else {
        const backofficeReason =
          reason || 'TAPON_BACKOFFICE_NO_CLIENTE';

        frontSonda.warningMessage({
          info: 'Tapón BackOffice no cliente',
        });

        yield spawn(sendPubSubMessage, {
          processId,
          userAgent,
          context,
          state: PUSSUB_STATES_DICTIONARY.PURCHASE.PROCESS.PROCESS_TO_GO,
          stateMessage: 'Tapon--BackOffice-No-cliente',
        });

        yield put(
          uiActions.setTapon(
            getTaponInfo(
              false,
              '500',
              backofficeReason,
            ),
          ),
        );
      }
      break;
    }

    default: {
      yield put(uiActions.setBouncingLogo(false));

      frontSonda.errorMessage({
        error: 'Proceso de compra no reconocido',
      });

      yield spawn(sendPubSubMessage, {
        processId,
        userAgent,
        context,
        state: PUSSUB_STATES_DICTIONARY.PURCHASE.PROCESS.PROCESS_TO_GO,
        stateMessage: 'Tapon',
      });

      yield put(
        uiActions.setTapon(
          getTaponInfo(
            client,
            '500',
            reason,
          ),
        ),
      );
      break;
    }
  }
}

function* getCustomerInfoAndSetInSecure() {
  const main = yield select(mainStore);
  const { context } = main;
  try {
    const customerInfoPromise = yield call(
      () => import('@gc-npm/adabyron.abs-layer.client.customer-info'),
    );
    const customerInfo = yield call(customerInfoPromise.getCustomerInfo, {
      context,
    });
    const { customer } = normalizeCustomerInfo(customerInfo);
    if (customer) {
      const localStorageLib = new LocalStorageLib();
      let newPersistedInfo = localStorageLib.getItem('ts');
      newPersistedInfo = {
        ...newPersistedInfo,
        customer,
      };
      localStorageLib.setItem('ts', newPersistedInfo);
    }
  } catch (error) {
    const frontSonda = new FrontSonda({
      processName: 'getCustomerInfoAndSetInSecure',
      context,
      filePath,
    });
    frontSonda.errorMessage({
      error,
    });
  }
}

export function* sendRetentionPromo({ promotions }) {
  const main = yield select(mainStore);
  const client = yield select(clientStore);
  const ui = yield select(uiStore);
  const cart = yield select(cartStore);
 const processId = ui?.processId;
 const userAgent = ui?.userAgent;
   const {
    bundleId,
    conexion,
    modulos,
    tv,
    oldTv,
    mobile,
    netflix,
    promotions: clientPromotions,
    campaignsRedeemed,
    productZoneId,
    productCategory,
    price: clientPrice,
    productType,
    r2r,
    bundleModules,
  } = client;
  const { context, zone } = main || {};
  const sessionZone = productZoneId || zone;
 const clientInfo = {
      modulos,
      promotions: clientPromotions,
      campaignsRedeemed,
      tv,
      oldTv,
      mobile,
      netflix,
      productZoneId,
      productCategory,
      productType,
      r2r,
      clientPrice,
      bundleId,
      conexion,
      bundleModules,
    };
  if (promotions && Array.isArray(promotions) && promotions.length > 0) {
    try {
      const retentionPromise = yield call(
        () => import('../sagas/adabyron/retention'),
      );
      const data = yield call(retentionPromise.retention, {
        context,
        clientInfo,
        promotions,
        selectedIds: cart?.modulos?.items,
        sessionZone,
      });

      const { retentionAction } = data || {};
      if (!retentionAction?.type) {
        throw new ReferenceError('retentionCatch', filePath);
      }

      if (retentionAction.type === RETENTION_ACTIONS.BACK_OFFICE) {
        yield call(sendOrder2BackOffice, retentionAction.payload);
        return;
      }

      if (retentionAction.type === RETENTION_ACTIONS.BACK_OFFICE_ERROR) {
        yield put(uiActions.setConfirmation(retentionAction.payload));
        return;
      }

      if (retentionAction.type === RETENTION_ACTIONS.ONE_CLICK) {
        const { processOrderExpressData, retentionInfo } = retentionAction.payload || {};
        try {
          const processOrderExpressPromise = yield call(
            () => import(
              '@gc-npm/adabyron.abs-layer.client.process-order-express'
            ),
          );
          const recaptchaToken = yield call(getReCaptchaToken, {
            action: 'OCS_SET_PROCESS_ORDER',
          });
          const processOrderExpress = yield call(
            processOrderExpressPromise.processOrderExpress,
            {
              data: processOrderExpressData,
              recaptchaToken,
              context,
            },
          );
          const status = processOrderExpress?.status === '209'
            ? CONFIRMATION_STATUS.REDEEMED // status 209 significa que ya la tiene en vuelo
            : CONFIRMATION_STATUS.OK;
            
          yield spawn(sendPubSubMessage, {processId, userAgent, context, state: PUSSUB_STATES_DICTIONARY.PURCHASE.PROCESS.PROCESS_TO_GO, stateMessage: 'Retargeting' });
          yield put(
            uiActions.setConfirmation({
              type: CONFIRMATION_TYPES.PREVENTION,
              status,
              info: retentionInfo && retentionInfo[status],
            }),
          );
          yield call(getCustomerInfoAndSetInSecure);
        } catch (error) {
          const status = CONFIRMATION_STATUS.KO;
          if (error.statusCode === 401) {
            
            if (!sessionStorage.getItem('retentionPromotions')) {
              const retentionPromotions = JSON.stringify(promotions);
              sessionStorage.setItem(
                'retentionPromotions',
                retentionPromotions,
              );
              yield spawn(sendPubSubMessage, {processId, userAgent, context, state: PUSSUB_STATES_DICTIONARY.PURCHASE.PROCESS.PROCESS_TO_GO, stateMessage: 'Retargeing_KO-sendToLogin' });
              yield call(navigate2Login, { sendRetentionPromo: '' });
            } else {
              
              // si ya ha intentado con login y falla de nuevo -> error
              yield put(
                uiActions.setConfirmation({
                  type: CONFIRMATION_TYPES.PREVENTION,
                  status,
                  info: retentionInfo && retentionInfo[status],
                }),
              );
              yield spawn(sendPubSubMessage, {processId,userAgent, context, state: PUSSUB_STATES_DICTIONARY.PURCHASE.PROCESS.PROCESS_TO_GO, stateMessage: 'Retargeting_KO-error tras volver a logar' });
              sessionStorage.removeItem('retentionPromotions');
            }
          } else {
            yield spawn(sendPubSubMessage, {processId,userAgent, context, state: PUSSUB_STATES_DICTIONARY.PURCHASE.PROCESS.PROCESS_TO_GO, stateMessage: 'Retargeting_error' });
            yield put(
              uiActions.setConfirmation({
                type: CONFIRMATION_TYPES.PREVENTION,
                status,
                info: retentionInfo && retentionInfo[status],
              }),
            );
          }
        }
        return;
      }

      throw new ReferenceError('unsupportedRetentionAction', filePath);
    } catch (error) {
      // TODO que textos pinta?
      yield spawn(sendPubSubMessage, {processId,userAgent, context, state: PUSSUB_STATES_DICTIONARY.PURCHASE.PROCESS.PROCESS_TO_GO, stateMessage: `Retargeting_error-${error?.message || JSON.stringify(error)}` });
      yield put(
        uiActions.setConfirmation({
          type: CONFIRMATION_TYPES.PREVENTION,
          status: CONFIRMATION_STATUS.KO,
        }),
      );
    }
  } else {
    // TODO que textos pinta?
    yield put(
      uiActions.setConfirmation({
        type: CONFIRMATION_TYPES.PREVENTION,
        status: CONFIRMATION_STATUS.KO,
      }),
    );
  }
}

export function* sendPubSub(data) {
  const main = yield select(mainStore);
  const ui = yield select(uiStore);
  const { context } = main;
  const processId = ui?.processId;
  const userAgent = ui?.userAgent;
  yield spawn(sendPubSubMessage, {
    ...data,
    context,
    processId,
    userAgent,
  });
}

export function* setMinorLmPrice({ modulos }) {
  if (!Array.isArray(modulos) || modulos.length === 0) return null;

  const prices = modulos
    .map(m => m?.promoPrice?.price ?? m?.price?.price)
    .filter(p => typeof p === "number" && !isNaN(p));

  if (prices.length === 0) return null; // Evita Math.min sobre array vacío
  const minorLMPrice = Math.min(...prices);
  yield put(uiActions.setMinorPriceLm(minorLMPrice)) 
}
